import { RefreshTokenErrorMessage } from "configs";
import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";
import { loadRefreshToken, saveAccessToken, saveRefreshToken } from "utils";

import Paths from "./paths";
import {
  AuthGetMeResponse,
  AuthRefreshTokenRequest,
  AuthRefreshTokenResponse,
  AuthSignInRequest,
  AuthSignInResponse,
} from "./types";

export const authLoginService = (params: AuthSignInRequest) =>
  RestAPIClient.call<AuthSignInResponse>({
    method: HTTPRequestMethods.POST,
    url: Paths.Login,
    data: params,
  });

export const authLogoutService = () =>
  RestAPIClient.call({
    method: HTTPRequestMethods.GET,
    url: Paths.Logout,
    config: { requireAuthentication: true },
  });

export const authUserInfoService = () =>
  RestAPIClient.call<AuthGetMeResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.UserInfo,
    config: { requireAuthentication: true },
  });

export const authRefreshTokenService = (params: AuthRefreshTokenRequest) =>
  RestAPIClient.call<AuthRefreshTokenResponse>({
    method: HTTPRequestMethods.POST,
    url: Paths.RefreshToken,
    data: params,
  });

export const authRefreshTokenHandler = () => {
  return new Promise<{ accessToken?: string }>((resolve, rejects) => {
    const refreshToken: string | null = loadRefreshToken();
    if (!refreshToken) throw new Error(RefreshTokenErrorMessage);
    authRefreshTokenService({ refreshToken })
      .then((res) => {
        const { accessToken: newAccessToken, refreshToken: newRefreshToken } =
          res?.data ?? {};
        if (!newAccessToken) return rejects;
        saveAccessToken(newAccessToken);
        saveRefreshToken(newRefreshToken ?? refreshToken);
        return resolve({ accessToken: newAccessToken });
      })
      .catch((error) => rejects(error));
  });
};
